<template>
	<div id="app">
		<transition
			name="fade"
			mode="out-in"
		>
			<component :is="layout">
				<router-view />
			</component>
		</transition>
		<notifications
			position="bottom right"
			class="notification-login"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['layout']),
	},
};
</script>

<style lang="scss">
@import "@/scss/base.scss";

</style>
